export const transformZeroToUndefined = (val) => {
  return val === 0 ? undefined : val
};
